import React from "react"

import { InputNumber } from "antd"
import cls from "classname"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import "./styles.less"

export const InputNumberComponent = React.forwardRef(({ onChange, className, ...props }, ref) => {
  const isDisabledTransition = useSelector((state) => state.nav.disabledTransition)

  return (
    <InputNumber
      onChange={onChange}
      className={cls(className, "input-number", {
        "disabled-transition": isDisabledTransition
      })}
      ref={ref || null}
      {...props}
    />
  )
})

InputNumberComponent.propTypes = {
  onChange: PropTypes.func,
  className: PropTypes.string
}

export default InputNumberComponent
